<template>
  <div class="merchant-list">
    <div class="merchant-list__row merchant-list__row--header" :class="[show ? 'show' : 'hide']">
      <div class="merchant-list__cell merchant-list__cell--name"></div>
      <div class="merchant-list__cell merchant-list__cell--name">NAME</div>
      <div class="merchant-list__cell merchant-list__cell--desc">DESCRIPTION</div>
      <div class="merchant-list__cell merchant-list__cell--added-on">
        <font-awesome-icon icon="calendar-alt" />
      </div>
    </div>

    <div
      v-for="(item, index) in allMerchants"
      :key="index"
      class="merchant-list__row merchant-list__table"
    >
      <div class="merchant-list__cell">
        <v-img :src="createMerchantUrl(item)" v-if="item.logo" class="merchant-list__cell--logo" />
      </div>
      <div class="merchant-list__cell">{{item.name}}</div>
      <div class="merchant-list__cell">{{item.description}}</div>
      <div class="merchant-list__cell">{{moment(item.ctime).format("DD-MM-YYYY")}}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "merchant-list",

  data() {
    return {
      toggle: false,
      show: true,
      lastScrollPos: 0
    };
  },

  methods: {
    createMerchantUrl(merchant) {
      return `${process.env.VUE_APP_IMAGE_URL}/merchant/${merchant.id}_${merchant.logo}`;
    },

    onScroll() {
      const currentPos =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentPos < 0) {
        return;
      }

      // Hide on scroll down
      if (Math.abs(currentPos - this.lastScrollPos) < 50) {
        return;
      }

      // Show on scroll up
      if (Math.abs(currentPos == this.lastScrollPos)) {
        return;
      }

      this.show = currentPos < this.lastScrollPos;
      this.lastScrollPos = currentPos;
    }
  },

  computed: {
    ...mapState({
      merchants: state => state.merchants
    }),

    allMerchants() {
      return this.merchants.items;
    }
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll);
  }
};
</script>

<style lang="sass" scoped>

.merchant-list
    display: flex
    flex-flow: column
    background: darken($dark-purple, 5%)

    &__row
        display: flex
        flex-flow: row
        max-height: 40px
        line-height: 14px
        color: $c-white
        border-bottom: 1px solid lighten($dark-purple, 5%)

        &:hover
            &:not(:first-of-type)
                background-color: rgba(darken($dark-purple, 20%), .4)
        
        &--header
            position: fixed
            width: 100%
            background: $bg-color
            color: $c-black
            padding: 10px 0
            box-shadow: -2px 5px 5px rgba(100, 100, 100, .2)
            z-index: 2


    &__table
        position: relative
        top: 25px

    &__cell
        display: flex
        align-items: center
        flex: 1
        margin: 0 10px

        &--logo
            margin-left: -20px
            border-radius: 50%
            transform: scale(.1)

.show
  transform: translate3d(0, 0%, 0)
  transition: all .1s

.hide
  transform: translate3d(0, -217%, 0)
  transition: all .5s
</style>